// Blend modes (Canva/Figma-style). Maps to the CSS `mix-blend-mode` property,
// which html2canvas honors on export and which thumbnails inherit, so a single
// `blendMode` field on the element drives canvas, export, and thumbnails.

export const BLEND_MODES = [
  { id: 'normal', label: 'Normal' },
  { id: 'multiply', label: 'Multiply' },
  { id: 'screen', label: 'Screen' },
  { id: 'overlay', label: 'Overlay' },
  { id: 'darken', label: 'Darken' },
  { id: 'lighten', label: 'Lighten' },
  { id: 'color-dodge', label: 'Color Dodge' },
  { id: 'color-burn', label: 'Color Burn' },
  { id: 'hard-light', label: 'Hard Light' },
  { id: 'soft-light', label: 'Soft Light' },
  { id: 'difference', label: 'Difference' },
];

const VALID = new Set(BLEND_MODES.map((m) => m.id));

// Element types that expose the blend-mode control.
const BLENDABLE = new Set(['image', 'frame', 'svg', 'shape', 'sticker']);

export function supportsBlendMode(type) {
  return BLENDABLE.has(type);
}

// Resolve the CSS mix-blend-mode value. 'normal' (and unknown/absent) → no
// blending; returns undefined so we don't emit a redundant style.
export function blendModeStyle(element) {
  const m = element && element.blendMode;
  if (!m || m === 'normal' || !VALID.has(m)) return undefined;
  return m;
}
